import { Tooltip } from "@mui/material";
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import { useProduct } from "../../store/product";
import l10n from "../../lib/l10n";
import ToggleFab from "../ToggleFab";
import { useCropperStore } from "@src/v3.0.0/store/cropper/cropper-store";
import { useAppStore } from "@src/v3.0.0/store/app";

function CanvasRepeatTool() {
  const {setIdle: setAppIdleStatus} = useAppStore();
  const {preset,updatePreset, setCropperChanged} = useCropperStore();
  const product = useProduct(s => s.product);
  const repeats = parseInt(l10n.wppr_cjs_min_repeats);
  
  if(!product.is_repeatable) {
    return null;
  }

  const onClick = (e) => {
    setAppIdleStatus();
    setCropperChanged();
    updatePreset({ repeats: preset.repeats < repeats ? repeats : 1 });
  };

  return (
    <Tooltip title="Ripeti la stampa" placement="top">
      <ToggleFab active={preset.repeats > 1} onClick={onClick}>
        <AllInclusiveIcon />
      </ToggleFab>
    </Tooltip>
  )
};

export default CanvasRepeatTool;